import { useConfigConditionValue } from 'features/config/useConfigConditionValue'
import DealsTopModal, { DealSelectCallback } from './DealsTopModal'

interface Props {
  open: boolean
  close?: () => void
  onSelect?: DealSelectCallback
}

export default function DealsModal({ open, close, onSelect }: Props) {
  const tagsConfig = useConfigConditionValue('intro:tags', 'tags')

  if (!tagsConfig) {
    return null
  }

  return (
    <DealsTopModal
      open={open}
      close={close}
      tags={tagsConfig}
      onSelect={onSelect}
    />
  )
}
